export const general_keywords = [
    "AutoCAD license key",
    "AutoCAD 1-year subscription",
    "AutoCAD for PC",
    "AutoCAD software 2018-2025",
    "AutoCAD drafting tools",
    "AutoCAD design software",
    "AutoCAD engineering tools",
    "AutoCAD 3D modeling",
    "AutoCAD architecture software",
    "AutoCAD 2018-2025 license for PC",
    "AutoCAD annual subscription",
    "AutoCAD PC license download",
    "AutoCAD precision tools",
    "AutoCAD 2D and 3D drafting",
    "AutoCAD building design software",
    "AutoCAD CAD tools",
    "AutoCAD professional tools",
    "AutoCAD software for architects",
    "AutoCAD structural design",
    "AutoCAD engineering and drafting",
    "AutoCAD for designers and engineers",
    "AutoCAD subscription plan",
    "AutoCAD 1-year PC license",
    "AutoCAD building modeling",
    "AutoCAD software for construction",
    "AutoCAD advanced tools",
    "AutoCAD for architectural design",
    "Revit license key",
    "Revit 1-year subscription",
    "Revit for PC",
    "Revit software 2022-2025",
    "Revit architectural tools",
    "Revit design software",
    "Revit engineering tools",
    "Revit architecture and MEP",
    "Revit modeling software",
    "Revit 2022-2025 license for architects",
    "Revit annual subscription",
    "Revit PC license download",
    "Revit 1-year architectural license",
    "Revit BIM software",
    "Revit construction tools",
    "Revit 2025 subscription",
    "Revit structural design",
    "Revit building design software",
    "Revit architecture software",
    "Revit CAD tools",
    "Revit 3D design software",
    "Revit 1-year license download",
    "Revit precision modeling tools",
    "Revit architecture and engineering",
    "Revit for architects and engineers",
    "Revit building modeling",
    "Revit PC software",
    "AutoCAD all apps subscription",
    "AutoCAD subscription",
    "AutoCAD for PC",
    "AutoCAD drafting tools",
    "AutoCAD all-in-one subscription",
    "AutoCAD professional tools",
    "AutoCAD 1-year subscription",
    "AutoCAD all applications license",
    "AutoCAD multi-discipline tools",
    "AutoCAD design and drafting",
    "AutoCAD engineering software",
    "AutoCAD suite for PC",
    "AutoCAD 2D and 3D design",
    "AutoCAD software for architects",
    "AutoCAD for engineers",
    "AutoCAD for designers",
    "AutoCAD complete toolset",
    "AutoCAD advanced drafting tools",
    "AutoCAD 1-year all access",
    "AutoCAD yearly license",
    "AutoCAD software 2023",
    "AutoCAD architecture tools",
    "AutoCAD full software suite",
    "AutoCAD precision design",
    "AutoCAD multi-discipline subscription",
    "AutoCAD for professionals",
    "AutoCAD 1-year full access",
    "AutoCAD construction tools",
    "AutoCAD for PC subscription",
    "AutoCAD access for designers",
    "Civil 3D license key",
    "AutoCAD Civil 3D subscription",
    "AutoCAD Civil 3D for PC",
    "AutoCAD Civil 3D software 2022-2025",
    "Civil 3D 1-year subscription",
    "Civil 3D engineering tools",
    "Civil 3D for infrastructure design",
    "AutoCAD Civil 3D modeling",
    "Civil 3D design software",
    "Civil 3D for land development",
    "Civil 3D PC license download",
    "AutoCAD Civil 3D advanced tools",
    "Civil 3D construction software",
    "Civil 3D survey tools",
    "AutoCAD Civil 3D precision modeling",
    "Civil 3D road design",
    "Civil 3D for civil engineering",
    "Civil 3D annual license",
    "Civil 3D software for architects",
    "Civil 3D for infrastructure projects",
    "Civil 3D 2023 software",
    "Civil 3D building design",
    "AutoCAD Civil 3D full suite",
    "Civil 3D for land surveying",
    "AutoCAD Civil 3D for PC subscription",
    "Civil 3D water management tools",
    "AutoCAD Civil 3D all features",
    "Civil 3D for topography",
    "Civil 3D BIM integration",
    "Civil 3D professional tools"
  ];
  